import React, { useEffect } from "react"
import { gql, useQuery, useLazyQuery } from "@apollo/client"

import { Fieldset, Modal } from "components"

import { Formik, Form, FieldArray } from "formik"

import * as yup from "yup"

import uniqBy from "lodash/uniqBy"

import cleanObject from "utils/cleanObject"

const passengerMock = {
  relationship: "Primary",

  firstName: "John",
  lastName: "Smith",

  email: "test@test.com",
  phone: "5554589993",

  gender: "Male",
  birthdate: "1975-04-23",

  street: "100 Main St",
  city: "Arbutus",
  state: "FL", //region
  zip: "32801",
  country: "USA",

  passportNumber: "499029343",
  passportExparationDate: "2022-09-22",
}

const PassengersFormModal = ({
  mode = "multiple",
  max,
  //
  isOpen,
  onClose,
  //
  bookingId,
  tripId,
  userId,
  //
  fields,
  data,
  //
  onCreate,
  onUpdate,
  onDelete,
}) => {
  const passengerModel = {
    relationship: "Primary",

    firstName: "",
    lastName: "",

    email: "",
    phone: "",

    gender: "",
    birthdate: "",

    street: "",
    city: "",
    state: "",
    zip: "",
    country: "USA",

    passportNumber: "",
    passportExparationDate: "",

    bookingId,
    tripId,
    userId,

    // ...passengerMock,
  }

  const passengerSchema = yup.object({
    ...(fields?.userId
      ? {
          relationship: yup
            .mixed()
            .oneOf([
              "Primary",
              "Spouse",
              "Child",
              "Travel Companion",
              "Business Partner",
              "Other",
            ])
            .required("Relationship is required"),
        }
      : {}),

    firstName: yup
      .string()
      .max(30, "Must be 30 characters or less")
      .required("First name is required"),
    lastName: yup
      .string()
      .max(30, "Must be 30 characters or less")
      .required("Last name is required"),
    email: yup.string().when(["relationship"], {
      is: "Primary",
      then: yup
        .string()
        .email("Invalid email address")
        .required("Email is required"),
      // otherwise: yup.number().min(0),
    }),
    phone: yup.string().when(["relationship"], {
      is: "Primary",
      then: yup.string().required("Phone number is required"),
      // otherwise: yup.number().min(0),
    }),
    // gender: yup.string().required("Gender is required"),
    // birthdate: yup.string().required("Birthdate is required"),

    ...(fields?.userId
      ? { booking: yup.object({}).required("Booked by is required") }
      : {}),

    // street: yup.string().when(["relationship"], {
    //   is: "Primary",
    //   then: yup.string().required("Street is required"),
    // }),
    // city: yup.string().when(["relationship"], {
    //   is: "Primary",
    //   then: yup.string().required("City is required"),
    // }),
    // state: yup.string().when(["relationship"], {
    //   is: "Primary",
    //   then: yup.string().required("State is required"),
    // }),
    // region: yup.string().when(["relationship"], {
    //   is: "Primary",
    //   then: yup.string(),
    // }),
    // zip: yup.string().when(["relationship"], {
    //   is: "Primary",
    //   then: yup.string().required("Zip is required"),
    // }),
    // passportNumber: yup.string().required("Passport number is required"),
    // passportExparationDate: yup
    //   .string()
    //   .required("Passport exparation date is required"),
  })

  const passengersSchema = yup.object({
    passengers: yup.array().of(passengerSchema),
  })

  const isEditing =
    mode === "multiple" && data.length > 0
      ? data.every((_) => _.id !== null)
      : data?.id

  const title = `${isEditing ? "Edit" : "Create"} Passengers`

  const formikProps = {
    initialValues: {
      ...(mode === "single"
        ? { ...passengerModel, ...data }
        : {
            passengers: [
              ...(data && data.length > 0
                ? data.map((item) => ({
                    ...item,

                    booking: data
                      ? {
                          key: item?.user?.id,
                          label: item?.user?.displayName,
                          value: {
                            bookingId: item?.bookingId
                              ? item?.bookingId
                              : bookingId,
                            tripId: item?.tripId ? item?.tripId : tripId,
                            userId: item?.userId ? item?.userId : userId,
                          },
                        }
                      : null,

                    // validFrom: formatDate(item.validFrom, "yyyy-LL-dd"),
                    // validTo: formatDate(item.validTo, "yyyy-LL-dd"),
                  }))
                : []),
            ],
          }),
    },
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: mode === "single" ? passengerSchema : passengersSchema,
    onSubmit: async (values, actions) => {
      try {
        //This is expensive because everytime this functions gets called update will happen
        //TODO detect if values chaged, and then update shallowDeep(inital, current)

        actions.setSubmitting(true)

        if (mode === "single") {
          const passengerWithoutEmptyAttr = cleanObject(values)

          values.id
            ? await onUpdate(passengerWithoutEmptyAttr)
            : await onCreate(passengerWithoutEmptyAttr)
        } else {
          // const initialDataIds = data?.map((_) => _.id)
          // const currentDataIds = values?.passengers?.map((_) => _.id)

          const passengers = values?.passengers?.map((item) => {
            const { booking, user, ...rest } = item
            return cleanObject({ ...rest, ...booking?.value })
          })

          isEditing ? onUpdate(passengers) : onCreate(passengers)

          // const passengersForCreate = passengers.filter((_) => !_.id)
          // const passengersForUpdate = passengers.filter(
          //   (_) => _.id && initialDataIds?.includes(_.id),
          // )
          // const passengersForDelete = data?.filter(
          //   (_) => _.id && !currentDataIds?.includes(_.id),
          // )

          // if (passengersForCreate?.length > 0) {
          //   await onCreate(passengersForCreate)
          // }

          // if (passengersForUpdate?.length > 0) {
          //   await onUpdate(passengersForUpdate)
          // }

          // if (passengersForDelete?.length > 0) {
          //   await onDelete(passengersForDelete)
          // }
        }

        onClose()
      } catch (e) {
        actions.setSubmitting(false)
        // const errors = e.graphQLErrors.map(v => v)
        // setFieldError("server", errors)
      }
    },
  }

  const handleDelete = async () => {
    try {
      await onDelete(data?.id)
      onClose()
    } catch (error) {}
  }

  return (
    <Modal title={title} isOpen={isOpen} onClose={onClose}>
      <Formik {...formikProps}>
        {({ values, errors, isSubmitting, setFieldValue }) => (
          <Form>
            {mode === "single" ? (
              <>
                <FieldPassenger prefix="" fields={fields} />
                <div>
                  {data?.id && (
                    <button
                      type="button"
                      onClick={handleDelete}
                      className="h-10 px-5 m-2 mt-4 text-red-100 transition-colors duration-150 bg-red-700 rounded-lg focus:shadow-outline hover:bg-red-800"
                    >
                      Delete Passenger
                    </button>
                  )}
                </div>
              </>
            ) : (
              <FieldArray
                name="passengers"
                render={(arrayHelpers) => (
                  <>
                    {values?.passengers?.map((passenger, index) => (
                      <>
                        <FieldPassenger
                          key={index}
                          index={index}
                          prefix={`passengers[${index}].`}
                          fields={fields}
                          tripId={tripId}
                          userId={userId}
                          {...passenger}
                          onDelete={() => arrayHelpers.remove(index)}
                        />
                        {isEditing && (
                          <button
                            type="button"
                            onClick={() => onDelete(passenger?.id)}
                            className="h-10 px-5 m-2 mt-4 text-red-100 transition-colors duration-150 bg-red-700 rounded-lg focus:shadow-outline hover:bg-red-800"
                          >
                            Delete Passenger
                          </button>
                        )}
                      </>
                    ))}

                    {!isEditing && values?.passengers?.length < max && (
                      <AddPassengerFiled
                        onCreate={(passenger) => {
                          arrayHelpers.push({
                            ...passengerModel,
                            ...passenger,
                          })
                          setFieldValue("passenger", null)
                        }}
                      />
                    )}
                  </>
                )}
              />
            )}

            {mode === "single" && (
              <div className="mt-6" role="alert">
                <div className="bg-blue-500 text-white font-bold rounded-t px-4 py-2">
                  Notice
                </div>
                <div className="border border-t-0 border-blue-400 rounded-b bg-blue-100 px-4 py-3 text-blue-700">
                  <p>This update will not be reflect on previous trips</p>
                </div>
              </div>
            )}

            <ModalNavigation {...{ isSubmitting, onClose }} />
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default PassengersFormModal

const ModalNavigation = ({ isSubmitting, onClose }) => {
  return (
    <div className=" px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
      <span className="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
        <button
          disabled={isSubmitting}
          type="submit"
          className="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-green transition ease-in-out duration-150 sm:text-sm sm:leading-5 disabled:opacity-50 disabled:cursor-wait"
        >
          Save
        </button>
      </span>

      <span className="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
        <button
          onClick={() => onClose()}
          type="button"
          className="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
        >
          Cancel
        </button>
      </span>
    </div>
  )
}

const AddPassengerFiled = ({ onCreate }) => {
  const PASSENGERS = gql`
    query Passengers(
      $filter: PassengerFilterInput
      $page: Int
      $size: Int
      $sort: PassengerSortInput
    ) {
      passengers(filter: $filter, page: $page, size: $size, sort: $sort) {
        id
        relationship
        firstName
        lastName
        email
        phone
        gender
        birthdate

        street
        city
        state
        region
        zip
        country

        passportNumber
        passportExparationDate

        # ADDITIONAL
        weight
        height
        size

        emergencyContactPerson
        specialRequest

        roomateRequest
        smoker
        newsletter
      }
    }
  `

  const variables = {
    page: 0,
    size: 10,
    // filter: { roles: ["ADMIN", "AGENT", "LEADER"] },
    // sort: { firstName: "ASC" },
  }

  const { data, loading, fetchMore } = useQuery(PASSENGERS, {
    variables,
    notifyOnNetworkStatusChange: true,
  })

  const passengers = data?.passengers?.map((passenger) => ({
    key: passenger.id,
    label: `${passenger.firstName} ${passenger.lastName} (${passenger.email})`,
    value: { ...passenger },
  }))

  const handleSearch = (_search, e) => {
    if (e.action === "input-change") {
      const search = _search?.toLowerCase()
      fetchMore({
        variables: { ...variables, filter: { ...variables.filter, search } },
        updateQuery: (prev, { fetchMoreResult }) => {
          if (!fetchMoreResult) return prev
          return Object.assign({}, prev, {
            users: uniqBy(
              [...prev?.users, ...fetchMoreResult?.users],
              "displayName",
            ),
          })
        },
      })
    }
  }

  return (
    <div className="my-8 py-8 px-2 bg-gray-50 border-t-2 border-b-2 border-gray-100">
      <Fieldset
        name="passenger"
        label="Passenger"
        component="select"
        options={passengers}
        cacheOptions
        // isMulti
        isLoading={loading}
        onInputChange={handleSearch}
        onSelect={(field) => onCreate(field.value)}
        getOptionValue={(opt) => opt.key}
        mapping={{ label: "displayName" }}
        placeholder="Type to select existing"
      />

      <div className="my-10 flex items-center space-x-4 w-full">
        <p>Or</p>
        <div className="w-full border-t-2 border-gray-200" />
      </div>

      <button
        type="button"
        onClick={() => onCreate({})}
        className="text-blue-500 hover:text-blue-700 py-2 px-1 rounded flex"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>

        <span className="ml-2">Create New Passenger</span>
      </button>
    </div>
  )
}

export const FieldPassenger = ({ prefix, tripId, userId, fields, index }) => {
  const BOOKINGS = gql`
    query Trip($id: ID!) {
      trip(id: $id) {
        id
        bookings {
          id

          user {
            id
            displayName
            email
          }
        }
      }
    }
  `

  const [getBookings, { data, loading, error, refetch }] = useLazyQuery(
    BOOKINGS,
    {
      variables: { id: tripId },
    },
  )

  const bookings = data?.trip?.bookings?.map((booking) => ({
    key: booking.user.id,
    label: booking.user.displayName,
    value: {
      bookingId: booking?.id,
      tripId,
      userId: booking?.user?.id,
    },
  }))

  useEffect(() => {
    if (tripId) {
      getBookings()
    }
  }, [tripId])

  return (
    <div className="w-full">
      {!userId && fields?.userId && (
        <div className="px-2 py-3 mt-2">
          <div className="w-6/12">
            <Fieldset
              name={`${prefix}booking`}
              label="Booked by *"
              component="select"
              options={bookings}
              cacheOptions
              isLoading={loading}
              // onInputChange={handleSearch}
              getOptionValue={(opt) => opt.key}
              placeholder="Select main traveler"
            />
          </div>
        </div>
      )}

      {tripId && (
        <div className="px-2 py-3 mt-2">
          <div className="w-6/12">
            <Fieldset
              type="select"
              label="Relationship"
              name={`${prefix}relationship`}
              options={[
                { label: "Primary", values: "Primary" },
                { label: "Spouse", values: "Spouse" },
                { label: "Child", values: "Child" },
                { label: "Travel Companion", values: "Travel Companion" },
                { label: "Business Partner", values: "Business Partner" },
                { label: "Other", values: "Other" },

                // "Primary",
                // "Spouse",
                // "Child",
                // "Travel Companion",
                // "Business Partner",
                // "Other",
              ]}
            />
          </div>
        </div>
      )}

      <div className="py-3 flex justify-between">
        <div className="px-2 flex-1">
          <Fieldset
            label="First name"
            name={`${prefix}firstName`}
            // autoFocus={isPrimary}
          />
        </div>

        <div className="px-2 flex-1">
          <Fieldset label="Last name" name={`${prefix}lastName`} />
        </div>
      </div>

      <div className="py-3 flex justify-between">
        <div className="px-2 flex-1">
          <Fieldset label="Email" type="email" name={`${prefix}email`} />
        </div>

        <div className="px-2 flex-1">
          <Fieldset label="Phone" type="phone" name={`${prefix}phone`} />
        </div>
      </div>

      <div className="py-3 flex justify-between">
        <div className="px-2 flex-1">
          <Fieldset
            type="select"
            label="Gender"
            name={`${prefix}gender`}
            options={[
              { label: "Male", values: "Male" },
              { label: "Female", values: "Female" },
              { label: "Other", values: "Other" },
              { label: "Undisclosed", values: "Undisclosed" },
            ]}
          />
        </div>
        <div className="px-2 flex-1">
          <Fieldset type="date" label="Birthdate" name={`${prefix}birthdate`} />
        </div>
      </div>

      {/* Additional Fields */}
      <div className="py-3 flex justify-between">
        {fields?.passportNumber && (
          <div className="px-2 flex-1">
            <Fieldset
              type="text"
              label="Passport no."
              name={`${prefix}passportNumber`}
            />
          </div>
        )}

        {fields?.passportExparationDate && (
          <div className="px-2 flex-1">
            <Fieldset
              type="date"
              label="Passport expiration date"
              name={`${prefix}passportExparationDate`}
            />
          </div>
        )}
      </div>

      <div className="py-3 flex justify-between">
        {fields?.weight && (
          <div className="px-2 flex-1">
            <Fieldset label="Weight" name={`${prefix}weight`} type="number" />
          </div>
        )}

        {fields?.height && (
          <div className="px-2 flex-1">
            <Fieldset label="Height" name={`${prefix}height`} type="number" />
          </div>
        )}

        {fields?.size && (
          <div className="px-2 flex-1">
            <Fieldset label="Shoe size" name={`${prefix}size`} type="number" />
          </div>
        )}
      </div>

      <div className="py-3 flex justify-between">
        {fields?.emergencyContactPerson && (
          <div className="px-2 flex-1">
            <Fieldset
              label="Emergency Contact Person"
              name={`${prefix}emergencyContactPerson`}
              component="textarea"
            />
          </div>
        )}

        {fields?.specialRequest && (
          <div className="px-2 flex-1">
            <Fieldset
              label="Special Request"
              name={`${prefix}specialRequest`}
              component="textarea"
            />
          </div>
        )}
      </div>

      {fields?.roomateRequest && (
        <div className="px-2 py-3">
          <Fieldset
            label="Roomate Request"
            name={`${prefix}roomateRequest`}
            component="text"
          />
        </div>
      )}

      {fields?.newsletter && (
        <div className="px-2 py-3">
          <Fieldset
            label="Newsletter"
            name={`${prefix}newsletter`}
            component="switch"
          />
        </div>
      )}
    </div>
  )
}
